import { cx } from './cx.ts'

export type DayChipProps = {
  name: string
  value: string
  /** Skrót dnia tygodnia, np. „Śr” albo „Dziś”. */
  weekday: string
  day: number
  checked: boolean
  available: boolean
  /** Lets a day without slots be picked anyway (Sunday shows an explanation instead of hours). */
  selectable?: boolean
  onChange: (value: string) => void
}

/**
 * Figma: `Day Chip / Kółko dnia` (`218:2`): etykieta dnia, kółko 46 px, kropka dostępności.
 * Natywny radio; brak terminów = disabled.
 */
export function DayChip({
  name,
  value,
  weekday,
  day,
  checked,
  available,
  selectable = available,
  onChange,
}: DayChipProps) {
  return (
    <label
      className={cx(
        'flex w-[60px] shrink-0 flex-col items-center gap-xs pb-[2px] text-[15px] tablet:gap-[7px] tablet:pt-1',
        selectable ? 'cursor-pointer' : 'cursor-not-allowed',
        checked ? 'font-bold text-text-primary' : 'font-medium text-text-secondary',
      )}
    >
      <span>{weekday}</span>
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        disabled={!selectable}
        onChange={() => onChange(value)}
        className="peer sr-only"
      />
      <span
        className={cx(
          'flex size-[46px] items-center justify-center rounded-pill text-[18px] font-extrabold transition-colors duration-150 peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-selected',
          checked
            ? 'bg-selected text-white'
            : available
              ? 'border border-border bg-bg-card text-text-primary'
              : 'border-[1.5px] border-border-soft bg-bg text-text-secondary',
        )}
      >
        {day}
      </span>
      <span
        aria-hidden="true"
        className={cx(
          'size-[6px] rounded-pill',
          // Figma `Wybrany` + `Brak`: a picked day without slots keeps the grey dot.
          !available ? 'bg-border-soft' : checked ? 'bg-selected' : 'bg-success',
        )}
      />
    </label>
  )
}
